import { Grid } from "@material-ui/core";
import React from "react";

export function LoadingPage(props: {message?: string}) {
	return (
		<Grid container justifyContent="center" alignItems="center" style={{ height: "100%" }}>
			<Grid item style={{paddingLeft: 5, paddingRight: 5}}>
				<img alt="Loading" width={"100%"} src="//i.cdn-sc.com/Logos/sc-full-logo.gif" />
			</Grid>
		</Grid>
	);
}
